import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** shadcn's class combiner: conditional classes via clsx, conflict resolution via
 *  tailwind-merge (so a caller's `p-4` beats a component's default `p-2`). */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
